import { IoCloseSharp, IoFilter, IoSearchSharp } from "react-icons/io5";
import Button from "../../../components/Button/button";
import {
  BlueTitle,
  LoadingGif,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  StyledHR,
} from "../../../shared/styles/global.styles";
import {
  AppliedFilters,
  FilterItem,
  FilterKey,
  FilterRemoveButton,
  FiltersContainer,
  FilterValue,
} from "./styles";
import loadSCGif from "../../../assets/load_SC.gif";
import React, { useEffect, useRef, useState } from "react";
import {
  FilterFichaFinanceiraDto,
  GetFinancialRecordDto,
} from "../../../shared/dtos/FichaFinanceira.dto";
import {
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  MenuTableDivider,
  ButtonAction,
  MenuTable,
  MenuTableItem,
  TableContainer,
} from "../../../components/Table/styles";
import Pagination from "../../../components/Pagination/pagination";
import Swal from "sweetalert2";
import { Label } from "../../../components/Label/styles";
import {
  ContainerButtons,
  ContainerFilter,
  CustomTableContainer,
  LoadingContainer,
} from "./styles";
import InputComponent from "../../../components/Input/input";
import { Colors } from "../../../shared/colors/colors";
import { MdOutlineViewColumn } from "react-icons/md";
import { Accordion, Dropdown } from "react-bootstrap";
import {
  DropdownDivider,
  DropdownScroll,
} from "../../../components/Dropdowns/styles";
import TabelaFiltroModal from "../../../components/TabelaFiltroModal/TabelaFiltroModal";
import {
  formatarData,
  formatDateToBR,
} from "../../../utils/dateUtils/dateUtils";
import FichaFinanceiraService from "../../../services/FichaFinanceiraService";
import { IoMdClose } from "react-icons/io";
import { SlOptionsVertical } from "react-icons/sl";
import DetailsModal from "../../../components/DetalheModal/detalhe_modal";
import QrCodeModal from "../../../components/QRCodeModal/qrCode_modal";
import { set } from "cypress/types/lodash";
import {
  GetLogRetornoDto,
  GetLogRetornosGroupTypeDto,
} from "../../../shared/dtos/LogRetornos";
import logRetornosService from "../../../services/logRetornosService";
import {
  StatusImpressaoEnum,
  StatusParcelaEnum,
} from "../../../shared/enum/fichaFinanceira.enum";

interface Props {
  id: number;
  type: "remessa" | "retorno";
  show: boolean;
  numeroSequencial: string;
  tipoRemessa: string;
  onClose: () => void;
  totalContribuintes?: number;
}

const ModalDetalhes: React.FC<Props> = ({
  id,
  type,
  show,
  numeroSequencial,
  tipoRemessa,
  totalContribuintes,
  onClose,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState<number | null>(null);
  const [showFiltroModal, setShowFiltroModal] = useState(false);
  const [appliedFilters, setAppliedFilters] =
    useState<FilterFichaFinanceiraDto>({});
  const [totalContribuintesModal, setTotalContribuintesModal] =
    useState<number>(totalContribuintes ?? 0);

  const [isSearch, setIsSearch] = useState(false);
  const [isRequest, setIsRequest] = useState<boolean>(false);
  const [isOpenMenuCollumn, setIsOpenMenuCollumn] = useState(false);
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>([]); // Estado temporário
  const [currentPage, setCurrentPage] = useState(1);
  const [totalParcelas, setTotalParcelas] = useState<number>(0);
  const [financialRecords, setFinancialRecords] = useState<
    GetFinancialRecordDto[]
  >([]);
  const [filteredRecords, setFilteredRecords] = useState<
    GetFinancialRecordDto[]
  >([]);
  const [
    fichaFinanceiraModalVisibleColumns,
    setFichaFinanceiraModalVisibleColumns,
  ] = useState<string[]>([]);
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(totalParcelas / itemsPerPage);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedRecord, setSelectedRecord] =
    useState<GetFinancialRecordDto | null>(null);
  const [showModalQRCode, setShowModalQRCode] = useState<boolean>(false);

  const defaultColumns = [
    "Contribuinte",
    "Nosso numero",
    "Tipo cobranca",
    "Valor parcela",
    "Vencimento",
  ];

  const loadVisibleColumns = () => {
    try {
      const savedColumns = sessionStorage.getItem(
        `fichaFinanceiraModalVisibleColumns`
      );
      if (!savedColumns)
        return setFichaFinanceiraModalVisibleColumns(defaultColumns);

      const parsedColumns = JSON.parse(savedColumns);
      setFichaFinanceiraModalVisibleColumns(
        parsedColumns.length > 0 ? parsedColumns : defaultColumns
      );
    } catch (error) {
      console.error("Erro ao carregar colunas:", error);
      return defaultColumns;
    }
  };

  const getDataByFilter = async (filter: FilterFichaFinanceiraDto) => {
    setIsRequest(true);
    if (filter.search) {
      setIsSearch(true);
    }

    let fichas: GetFinancialRecordDto[] = [];
    let total: number = 0;

    try {
      const response = await FichaFinanceiraService.filterParcelaByRemittance(
        id,
        filter,
        currentPage,
        itemsPerPage
      );
      if (response) {
        fichas = response.fichas;
        total = response.total;
      }

      if (fichas.length > 0) {
        setFilteredRecords(fichas);
        setTotalParcelas(total);
      } else if (
        total === 0 &&
        Object.keys(filter).some(
          (key) => (filter as any)[key] !== "" && (filter as any)[key] !== 0
        )
      ) {
        // Só mostra o alerta se o total de parcelas for zero (não há resultados em nenhuma página)
        setFilteredRecords(fichas);
        setTotalParcelas(0);
        Swal.fire({
          title: "Aviso",
          text: "Nenhuma parcela encontrada com os filtros selecionados.",
          icon: "info",
          allowOutsideClick: false,
        });
      } else {
        // Caso haja parcelas, mas não na página atual
        setFilteredRecords(fichas);
        setTotalParcelas(total);
      }
    } catch (error: any) {
      console.error("Erro ao buscar dados:", error);
      setFilteredRecords([]);
      setTotalParcelas(0);

      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao buscar os dados. Por favor, tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    } finally {
      setIsRequest(false);
    }
  };

  const formatFilterName = (filterName: string) => {
    return filterName
      .replace(/([A-Z])/g, " $1") // Insere espaço antes de letras maiúsculas
      .replace(/^./, (str) => str.toUpperCase()) // Capitaliza a primeira letra
      .trim(); // Remove espaços no início e no final
  };

  // Função para alternar colunas no estado temporário
  const handleColumnToggle = (column: string) => {
    setTempVisibleColumns((prev: string[]) => {
      // Se a coluna é padrão, não permite desmarcar
      if (defaultColumns.includes(column) && prev.includes(column)) {
        return prev;
      }

      // Toggle normal para colunas não padrão
      return prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column];
    });
  };

  // Função para aplicar as mudanças
  const handleApplyColumns = () => {
    setFichaFinanceiraModalVisibleColumns(tempVisibleColumns); // Atualiza as colunas visíveis
    sessionStorage.setItem(
      "fichaFinanceiraModalVisibleColumns",
      JSON.stringify(tempVisibleColumns)
    ); // Salva no sessionStorage
    setIsOpenMenuCollumn(false); // Fecha o dropdown
  };

  const applyFilters = async (filters: FilterFichaFinanceiraDto) => {
    try {
      // Converte os filtros para o formato esperado pela API
      const params = Object.entries(filters).reduce((acc, [key, value]) => {
        // Ignora valores vazios
        if (!value || value.toString().trim() === "") {
          return acc;
        }

        if (key === "statusParcela") {
          // Converte para o formato correto do enum no backend
          acc[key] =
            value.toString().charAt(0).toUpperCase() +
            value.toString().slice(1).toLowerCase();
        } else {
          acc[key] = value;
        }

        return acc;
      }, {} as Record<string, any>);

      const newFilter = { ...appliedFilters, ...params };

      setCurrentPage(1);
      setAppliedFilters(newFilter);
      getDataByFilter(newFilter);

    } catch (error) {
      console.error("Erro ao aplicar filtros:", error);
      // Reseta os filtros em caso de erro
      setFilteredRecords(financialRecords);

      Swal.fire({
        title: "Erro",
        text: "Não foi possível aplicar os filtros. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  const clearFilters = () => {
    setFilteredRecords(financialRecords); // Reseta os registros filtrados
  };

  const handleRemoveFilter = async (filterKey: string) => {
    const newFilters = { ...appliedFilters };

    // Remove o filtro especificado
    if (["dataVencimentoInicio", "dataVencimentoFim"].includes(filterKey)) {
      // Remove tanto a dataVencimentoInicio quanto a dataVencimentoFim do objeto newFilters
      delete newFilters.dataVencimentoInicio;
      delete newFilters.dataVencimentoFim;
    } else if (
      ["dataPagamentoInicio", "dataPagamentoFim"].includes(filterKey)
    ) {
      delete newFilters.dataPagamentoInicio;
      delete newFilters.dataPagamentoFim;
    } else {
      delete newFilters[filterKey as keyof FilterFichaFinanceiraDto];
    }
    getDataByFilter(newFilters);
    setAppliedFilters(newFilters);

  };

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber); // Isso dispara o useEffect que busca os dados
    }
  };

  const handleClearSearchInput = () => {
    setIsSearch(false);
    setSearchValue("");

    const clearFilter = { ...appliedFilters, search: "" };

    setAppliedFilters(clearFilter);

    getDataByFilter(clearFilter);
  };

  const handleSearchChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value;
    setSearchValue(searchValue);
    if (searchValue === "") {
      handleClearSearchInput();
    } else {
      const newFilter = { ...appliedFilters, search: searchValue };
      setAppliedFilters(newFilter);
    }
  };

  const handleSearchInput = () => {
    if (searchValue !== "") {
      setIsSearch(true);
      const newFilter: FilterFichaFinanceiraDto = {
        search: searchValue,
      };
      setCurrentPage(1);
      setAppliedFilters(newFilter);
      getDataByFilter(newFilter);
    } else {
      handleClearSearchInput();
    }
  };

  const toggleDropdown = (id: number) => {
    setIsOpen(id === isOpen ? null : id);
  };

  const createBillOfPay = async (
    fichasFinanceiras: GetFinancialRecordDto[]
  ) => {
    const data = {
      idFichaFinanceira: fichasFinanceiras.map((fichas) => fichas.id),
    };

    try {
      Swal.fire({
        title: "Carregando",
        text: "Carregando boletos...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await FichaFinanceiraService.createBillOfPay(data);
      if (response.success) {
        // Abrir o PDF
        window.open(
          `${process.env.REACT_APP_API_URL}pdfs/${response.data.nameFile}`,
          "_blank"
        );

        // Aguardar 1 segundo antes de deletar (tempo para o navegador abrir o PDF)
        setTimeout(async () => {
          const deleteResponse = await FichaFinanceiraService.deleteFileInPdfs(
            response.data.nameFile
          );

          if (deleteResponse.success) {
            const firstResult = await Swal.fire({
              title: "Sucesso!",
              text: "Os boletos foram carregados com sucesso!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        }, 2000); // tempo em milissegundos
      } else {
        Swal.fire({
          title: "Erro",
          text: "Ocorreu um erro ao gerar o boleto. Por favor, tente novamente.",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao gerar o PDF. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  useEffect(() => {
    getDataByFilter(appliedFilters); // Se o valor estiver vazio, busca normalmente
  }, [currentPage]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(Math.max(totalPages, 1)); // Garante que a página seja válida
    }
  }, [totalPages]);

  useEffect(() => {
    loadVisibleColumns();
    setSearchValue("");
    const newFilter: FilterFichaFinanceiraDto = {};
    setAppliedFilters(newFilter);
    getDataByFilter(newFilter);
  }, [id, type, show]);

  useEffect(() => {
    // Função para fechar o menu se o clique for fora dele
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpenMenuCollumn(false); // Fecha o dropdown
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpenMenuCollumn) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenMenuCollumn]);

  useEffect(() => {
    if (isOpenMenuCollumn) {
      setTempVisibleColumns(fichaFinanceiraModalVisibleColumns);
    }
  }, [isOpenMenuCollumn, fichaFinanceiraModalVisibleColumns]);
  const menuRefsMap = useRef<Map<number, HTMLDivElement | null>>(new Map());
  return (
    <ModalContainer show={show}>
      <ModalContent width={65}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>
            {type === "retorno" ? "Retorno de" : "Remessa de"} {tipoRemessa} #
            {numeroSequencial}
          </BlueTitle>
        </ModalHeader>
        <ModalBody>
          <>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSearchInput();
              }}
            >
              <ContainerFilter>
                <div>
                  <Label htmlFor="cpf-search" id="form-label">
                    Pesquisar pelo Nosso Número, Nome/CPF do contribuinte.
                  </Label>
                  <InputComponent
                    type="text"
                    id="search"
                    value={searchValue}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const value = e.target.value.replace(",", ".");
                      handleSearchChange({
                        ...e,
                        target: { ...e.target, value },
                      });
                    }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Impede o comportamento padrão de submissão do formulário
                        handleSearchInput();
                      }
                    }}
                    placeholder="Busque pelo Nosso Número, Nome/CPF contribuinte"
                    maxLength={45}
                    color="black"
                    width={399}
                    iconRight={
                      isSearch ? (
                        <IoCloseSharp size={24} color={Colors.inputIcon} />
                      ) : (
                        <IoSearchSharp size={24} color={Colors.inputIcon} />
                      )
                    }
                    onIconRightClick={() => {
                      isSearch ? handleClearSearchInput() : handleSearchInput();
                    }}
                    disabled={isRequest}
                  />
                </div>
                <ContainerButtons>
                  <Button
                    schemaButton="out-primary"
                    action={() => setIsOpenMenuCollumn(!isOpenMenuCollumn)}
                    icon={
                      <MdOutlineViewColumn
                        size={20}
                        style={{ marginRight: "8px" }}
                      />
                    }
                  >
                    Colunas
                  </Button>

                  <Dropdown.Menu
                    ref={dropdownMenuRef}
                    show={isOpenMenuCollumn}
                    style={{ marginTop: "50px" }}
                  >
                    <DropdownScroll>
                      {[
                        "Contribuinte",
                        "CPF",
                        "Parcela",
                        "Sequencial parcela",
                        "Nosso numero",
                        "Tipo cobranca",
                        "Valor parcela",
                        "Vencimento",
                        "Retorno",
                        "Ajuste",
                        "Valor pago",
                        "Tarifa",
                        "Data pagamento",
                        "Status impressao",
                        "Status remessa",
                      ].map((column, index, array) => (
                        <React.Fragment key={column}>
                          {!defaultColumns.includes(column) && (
                            <Dropdown.Item
                              eventKey="1"
                              onClick={() => handleColumnToggle(column)}
                              style={{ color: Colors.primary }}
                            >
                              <>
                                <img
                                  src={
                                    tempVisibleColumns.includes(column)
                                      ? "/images/checkbox-marked.svg"
                                      : "/images/checkbox-blank-outline.svg"
                                  }
                                  alt={
                                    tempVisibleColumns.includes(column)
                                      ? defaultColumns.includes(column)
                                        ? "Bloqueado"
                                        : "Selecionado"
                                      : "Não selecionado"
                                  }
                                  className="checkbox-image"
                                />
                                <label>{column}</label>
                                {array
                                  .filter(
                                    (col) => !defaultColumns.includes(col)
                                  )
                                  .indexOf(column) <
                                  array.filter(
                                    (col) => !defaultColumns.includes(col)
                                  ).length -
                                    1 && <DropdownDivider />}
                              </>
                            </Dropdown.Item>
                          )}
                        </React.Fragment>
                      ))}
                    </DropdownScroll>
                    {JSON.stringify(tempVisibleColumns.sort()) !==
                      JSON.stringify(
                        fichaFinanceiraModalVisibleColumns.sort()
                      ) && (
                      <Dropdown.Item>
                        <MenuTableDivider />
                        <Button
                          schemaButton="with-margin"
                          action={handleApplyColumns} // Aplica as mudanças ao clicar
                        >
                          Aplicar
                        </Button>
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>

                  <Button
                    schemaButton="full-primary"
                    action={() => setShowFiltroModal(true)}
                    icon={<IoFilter size={20} style={{ marginRight: "8px" }} />}
                  >
                    Adicionar filtro
                  </Button>
                </ContainerButtons>
              </ContainerFilter>
            </form>

            {showFiltroModal && (
              <TabelaFiltroModal
                onClose={() => setShowFiltroModal(false)}
                onApplyFilters={applyFilters}
                onClearFilters={clearFilters}
                initialValues={appliedFilters}
                show={showFiltroModal}
              />
            )}

            {Object.entries(appliedFilters).length > 0 &&
              Object.entries(appliedFilters).some(
                ([key]) => key !== "search"
              ) && (
                <AppliedFilters>
                  <i className="fa fa-filter" aria-hidden="true"></i>
                  <p>Filtros aplicados:</p>
                  <FiltersContainer>
                    {Object.entries(appliedFilters).length > 0 ? (
                      Object.entries(appliedFilters).map(([key, value]) => {
                        let formattedValue = value;

                        if (
                          key === "dataPagamentoInicio" &&
                          appliedFilters["dataPagamentoFim"]
                        ) {
                          const dataPagamentoInicio = formatDateToBR(
                            value.split("T")[0]
                          );
                          const dataPagamentoFim = formatDateToBR(
                            appliedFilters["dataPagamentoFim"].split("T")[0]
                          );
                          formattedValue = `${dataPagamentoInicio} - ${dataPagamentoFim}`;
                          return (
                            <FilterItem key="intervaloPagamento">
                              <FilterKey>Intervalo Pagamento: </FilterKey>
                              <FilterValue>{formattedValue}</FilterValue>
                              <FilterRemoveButton
                                onClick={() => {
                                  handleRemoveFilter("dataPagamentoInicio");
                                  handleRemoveFilter("dataPagamentoFim");
                                }}
                              >
                                <img
                                  src="/images/close.svg"
                                  alt="Remove filter"
                                />
                              </FilterRemoveButton>
                            </FilterItem>
                          );
                        }

                        if (
                          key === "dataVencimentoInicio" &&
                          appliedFilters["dataVencimentoFim"]
                        ) {
                          const dataVencimentoInicio = formatDateToBR(
                            value.split("T")[0]
                          );
                          const dataVencimentoFim = formatDateToBR(
                            appliedFilters["dataVencimentoFim"].split("T")[0]
                          );
                          formattedValue = `${dataVencimentoInicio} - ${dataVencimentoFim}`;
                          return (
                            <FilterItem key="intervalo">
                              <FilterKey>Intervalo de vencimento: </FilterKey>
                              <FilterValue>{formattedValue}</FilterValue>
                              <FilterRemoveButton
                                onClick={() => {
                                  handleRemoveFilter("dataVencimentoInicio");
                                  handleRemoveFilter("dataVencimentoFim");
                                }}
                              >
                                <img
                                  src="/images/close.svg"
                                  alt="Remove filter"
                                />
                              </FilterRemoveButton>
                            </FilterItem>
                          );
                        }

                        if (key === "search") {
                          return null;
                        }

                        if (
                          key === "dataVencimento" ||
                          key === "dataPagamento" ||
                          key === "intervalo"
                        ) {
                          formattedValue = formatarData(value);
                        }

                        if (
                          key !== "dataVencimentoInicio" &&
                          key !== "dataVencimentoFim" &&
                          key !== "dataPagamentoInicio" &&
                          key !== "dataPagamentoFim"
                        ) {
                          return (
                            <FilterItem key={key}>
                              <FilterKey>{formatFilterName(key)}: </FilterKey>
                              <FilterValue>{formattedValue}</FilterValue>
                              <FilterRemoveButton
                                onClick={() => handleRemoveFilter(key)}
                              >
                                <img
                                  src="/images/close.svg"
                                  alt="Remove filter"
                                />
                              </FilterRemoveButton>
                            </FilterItem>
                          );
                        }

                        return null;
                      })
                    ) : (
                      <p></p>
                    )}
                  </FiltersContainer>
                </AppliedFilters>
              )}
            <CustomTableContainer>
              <TableContainer>
                {isRequest ? (
                  <LoadingContainer>
                    <LoadingGif src={loadSCGif} alt="Carregando..." />
                  </LoadingContainer>
                ) : (
                  <>
                    <Table
                      style={{ marginTop: 20, marginBottom: 40 }}
                      firstColSmall={true}
                      id="tabela-ficha-financeira"
                    >
                      <TableHead>
                        <TableRow>
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Contribuinte"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Contribuinte
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "CPF"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              CPF
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Parcela"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Parcela
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Sequencial parcela"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Sequencial parcela
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Nosso numero"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Nosso N°
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Tipo cobranca"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Tipo cobrança
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Valor parcela"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Valor Parcela
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Vencimento"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Vencimento
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Ajuste"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Ajuste
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Valor pago"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Valor pago
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Tarifa"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Tarifa
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Data pagamento"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Data pagamento
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Status impressao"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Status impressão
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Status remessa"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Status remessa
                            </TableHeader>
                          )}
                          {fichaFinanceiraModalVisibleColumns.includes(
                            "Retorno"
                          ) && (
                            <TableHeader style={{ textAlign: "center" }}>
                              Retorno
                            </TableHeader>
                          )}
                          <TableHeader style={{ textAlign: "center" }}>
                            Ações
                          </TableHeader>
                        </TableRow>
                      </TableHead>
                      <tbody>
                        {filteredRecords && filteredRecords.length ? (
                          filteredRecords.map((record, index) => (
                            <TableRow key={index}>
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Contribuinte"
                              ) && (
                                <TableData style={{ textAlign: "start" }}>
                                  {record.contribuinte?.nome}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "CPF"
                              ) && (
                                <TableData style={{ textAlign: "start" }}>
                                  {record.contribuinte?.cpfCin}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Parcela"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.statusParcela}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Sequencial parcela"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.sequencialParcela}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Nosso numero"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.nossoNumero}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Tipo cobranca"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.tipoCobranca}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Valor parcela"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {new Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  }).format(Number(record.valorParcela))}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Vencimento"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.dataVencimento
                                    ? formatarData(
                                        record.dataVencimento as string
                                      )
                                    : "-"}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Ajuste"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {Number(record.valorAjuste) < 0
                                    ? `- R$ ${new Intl.NumberFormat("pt-BR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }).format(
                                        Math.abs(Number(record.valorAjuste))
                                      )}`
                                    : new Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                      }).format(Number(record.valorAjuste))}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Valor pago"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {new Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  }).format(Number(record.valorPago))}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Tarifa"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {new Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  }).format(Number(record.valorTarifa))}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Data pagamento"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.dataPagamento
                                    ? formatarData(
                                        record.dataPagamento as string
                                      )
                                    : "-"}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Status impressao"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.statusImpressao}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Status remessa"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.statusRemessa}
                                </TableData>
                              )}
                              {fichaFinanceiraModalVisibleColumns.includes(
                                "Retorno"
                              ) && (
                                <TableData style={{ textAlign: "center" }}>
                                  {record.retorno?.fileName
                                    ? record.retorno?.fileName
                                    : " "}
                                </TableData>
                              )}

                              <TableData
                                style={{
                                  position: "relative",
                                  overflow: "visible",
                                }}
                              >
                                <ButtonAction
                                  onClick={() => toggleDropdown(record.id)}
                                  style={{ marginLeft: "auto" }}
                                >
                                  {isOpen === record.id ? (
                                    <IoMdClose
                                      cursor={"pointer"}
                                      size={20}
                                      style={{ color: Colors.primary }}
                                    />
                                  ) : (
                                    <SlOptionsVertical
                                      cursor={"pointer"}
                                      size={20}
                                      style={{ color: Colors.primary }}
                                    />
                                  )}
                                </ButtonAction>
                                <MenuTable
                                  style={{
                                    right:
                                      filteredRecords.length === 1 ? "80%" : "",
                                    bottom:
                                      filteredRecords.length === 1
                                        ? filteredRecords.length * -19
                                        : "",
                                  }}
                                  show={isOpen === record.id}
                                  align="start"
                                  isLastRows={
                                    filteredRecords.indexOf(record) === 0
                                      ? true
                                      : filteredRecords.length > 0 &&
                                        filteredRecords.indexOf(record) >=
                                          filteredRecords.length -
                                            Math.ceil(
                                              filteredRecords.length / 2
                                            )
                                  }
                                  ref={(el: HTMLDivElement | null) => {
                                    // Armazena a referência no mapa usando o ID do registro como chave
                                    menuRefsMap.current.set(record.id, el);
                                  }}
                                >
                                  {/* {record.retorno?.fileName && (
                                <>
                                  <MenuTableItem
                                    onClick={() => {
                                      getRemessaRetorno(
                                        record.retorno?.fileName!
                                      );
                                    }}
                                  >
                                    Ver Retorno
                                  </MenuTableItem>
                                  <MenuTableDivider />
                                </>
                              )} */}

                                  <MenuTableItem
                                    onClick={() => {
                                      setSelectedRecord(record);
                                      setShowDetailsModal(true);
                                      setIsOpen(null);
                                    }}
                                  >
                                    Ver Parcela
                                  </MenuTableItem>
                                  <MenuTableDivider />
                                  {record.statusParcela !==
                                    StatusParcelaEnum.CANCELADA &&
                                    record.statusImpressao !==
                                      StatusImpressaoEnum.NAO_IMPRIMIR &&
                                    record.statusImpressao !==
                                      StatusImpressaoEnum.PENDENTE && (
                                      <>
                                        <MenuTableItem
                                          onClick={() => {
                                            createBillOfPay([record]);
                                            setIsOpen(null);
                                          }}
                                        >
                                          Imprimir
                                        </MenuTableItem>
                                        <MenuTableDivider />
                                      </>
                                    )}

                                  {record.statusParcela !==
                                    StatusParcelaEnum.CANCELADA &&
                                    record.qrCodePix &&
                                    record.qrCodePix !== "" && (
                                      <>
                                        <MenuTableItem
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedRecord(record);
                                            setShowModalQRCode(true);
                                            setIsOpen(null);
                                          }}
                                        >
                                          Detalhes do PIX
                                        </MenuTableItem>
                                        <MenuTableDivider />
                                      </>
                                    )}
                                </MenuTable>
                              </TableData>
                            </TableRow>
                          ))
                        ) : (
                          <tr>
                            <TableData
                              className="text-center text-muted"
                              colSpan={
                                fichaFinanceiraModalVisibleColumns.length + 1
                              }
                            >
                              Nenhuma parcela cadastrada.
                            </TableData>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </>
                )}
              </TableContainer>
            </CustomTableContainer>
          </>

          {selectedRecord && (
            <>
              <DetailsModal
                show={showDetailsModal}
                onClose={() => setShowDetailsModal(false)}
                record={selectedRecord}
                setShowQrCodeModal={setShowModalQRCode}
              />
              <QrCodeModal
                show={showModalQRCode}
                onClose={() => setShowModalQRCode(false)}
                qrCode={selectedRecord?.qrCodePix}
              />
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default ModalDetalhes;
